export default __webpack_public_path__ + "static/media/exchange.4f5b43fa.svg";